
export { mySociosFeedKeys } from "/home/runner/work/capsicum/capsicum/libs/socios-core/shared/feeds/models/feed-query-keys.ts"